<template>
  <div class="container">
    <div class="oferta-container">
      <wrap-container class="padding-17-left-right">
        <span class="titles">
          <p id="titulo" class="titulo p28 oscuro">
            Gracias <span data-obfuscate>{{ nombre }}</span
            >,
          </p>
        </span>
      </wrap-container>
      <wrap-container class="grid-container grid-container--6-6">
        <wrap-container class="col1 padding-17-left-right">
          <p id="subtitulo" class="titulo p32 oscuro medium">
            Vamos a contactarte pronto
          </p>
          <p class="description">
            Nos comunicaremos a través de los medios que nos compartiste
          </p>
          <wrap-container class="icons-container">
            <wrap-container
              class="instruction"
              v-for="instruction in instructions"
              :key="instruction.label"
            >
              <img
                class="icon"
                :src="
                  instruction.icon
                    ? require(`@/assets/img/1x/${instruction.icon}`)
                    : require(`@/assets/img/1x/0info.svg`)
                "
                alt="Ícono información"
              />
              <p class="instruction-label">{{ instruction.label }}</p>
              <p class="instruction-description">
                <span data-obfuscate>{{ instruction.description }}</span>
              </p>
            </wrap-container>
          </wrap-container>
        </wrap-container>
        <wrap-container class="col2 image-container">
          <img class="image" src="@/assets/img/1x/chat.svg" alt="Chatear" />
        </wrap-container>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "NoCliente",
  components: {
    WrapContainer
  },
  computed: {
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    },
    email() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.email) {
        return consulta.email;
      }
      return "";
    },
    celular() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.celular) {
        return consulta.celular;
      }
      return "";
    },
    instructions() {
      return [
        {
          icon: "calendar.svg",
          label: "Cuándo",
          description: "En los próximos 3 días hábiles"
        },
        {
          icon: "clock.svg",
          label: "Hora",
          description: "Entre las 9:00 y las 17:00 hs."
        },
        {
          icon: "email.svg",
          label: "Te vamos a escribir a",
          description: this.email
        },
        {
          icon: "telephone.svg",
          label: "Te vamos a llamar al",
          description: `(${this.celular.area}) ${this.celular.numero}`
        }
      ];
    }
  }
};
</script>
<style scoped>
.container {
  margin-top: 20px;
  margin-bottom: 50px;
}
div.container {
  height: 100%;
}
.oferta-container {
  max-width: 1200px;
  margin: 0 auto;
}
p {
  margin-top: 0px;
  margin-bottom: 0px;
}
p#titulo {
  margin-bottom: 8px;
}
p#subtitulo {
  margin-bottom: 0px;
  max-width: 500px;
}
.image {
  display: block;
  margin-bottom: 8px;
  margin-left: auto;
  margin-right: auto;
}
.description {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: -0.29px;
  color: #121212;
  margin-bottom: 32px;
  margin-top: 16px;
}
.instruction {
  margin-bottom: 40px;
}
.icon {
  width: 24px;
  margin-bottom: 16px;
}
.instruction-label {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 20px;
}
.instruction-description {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
}
.icons-container {
  display: grid;
  grid-template-columns: auto auto;
}
@media screen and (max-width: 900px) {
  .icons-container {
    display: flex;
    flex-direction: column;
  }
  .instruction {
    margin-bottom: 24px;
  }
  .image {
    width: 250px;
  }
}
@media screen and (max-width: 599px) {
  .container {
    margin-top: 0px;
  }
  #titulo {
    font-size: 20px;
    margin-bottom: 8px;
  }
  #subtitulo {
    font-size: 26px;
    margin-bottom: 4px;
  }
  .image {
    display: none;
  }
  .image-container {
    background-color: #cae8fc;
  }
  .description {
    width: 100%;
    margin-bottom: 24px;
  }
  .offer-group {
    margin-top: 32px;
  }
  .titles {
    display: inline;
  }
  .icons-container {
    display: flex;
    flex-direction: column;
  }
  .instruction {
    margin-bottom: 24px;
  }
}
</style>
